(function () {
  function initFaq(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';

    root.querySelectorAll('[data-rof-faq-item]').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('[data-rof-faq-item][open]').forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  }

  document.querySelectorAll('[data-rof-faq]').forEach(initFaq);
})();
